module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"website":"Офіційний сайт","defaultTitle":"Про школу"},"en":{"website":"Official website","defaultTitle":"About school"}}')
  delete Component.options._Ctor
}
